import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import { debounce } from '~/utils/utils'

const collection = () => ({
  swiper: null,
  handleResize: () => {},

  init() {
    this.initSwiper()
    this.handleResize = debounce(() => this.initSwiper(), 500)
    window.addEventListener('resize', this.handleResize)
  },

  initSwiper() {
    this.swiper?.destroy?.()
    this.swiper = null

    const image = this.$refs.swiperEl.querySelector('.card-product .images')

    if (image) {
      this.$refs.swiperEl.style.setProperty(
        '--image-height',
        `${image.clientHeight}px`
      )
    }
    this.swiper = new Swiper(this.$refs.swiperEl, {
      modules: [Navigation],
      slidesPerView: 'auto',
      loop: false,
      navigation: {
        nextEl: this.$refs.nextButton,
        prevEl: this.$refs.prevButton,
      },
    })
  },

  refreshSwiper() {
    this.swiper?.update?.()
  },

  destroy() {
    this.swiper?.destroy?.()
    window.removeEventListener('resize', this.handleResize)
  },
})

export default collection
